{
  "1回の上限": "Per Download",
  "8文字以上128文字以下で、大文字（A-Z）、小文字（a-z）、数字（0-9）、特殊文字（#?!@$%^&*-）をそれぞれ1文字以上含むよう設定してください。": "Please set a password that is at least 8 characters and no more than 128 characters long, including at least one uppercase letter (A-Z), one lowercase letter (a-z), one number (0-9), and one special character (#?!@$%^&*-).",
  "Basic(無料)プランではじめる": "Start with Basic plan (free)",
  "CSVダウンロード": "Download CSV",
  "Multinational 表示": "Display \"Multinational\"",
  "Plusプランで始める": "Start with Plus",
  "Plusプランにアップグレード": "Upgrade to Plus Plan",
  "組織の契約プランを利用する場合は、所属する組織の管理者へご連絡ください。": "To use an organization's subscription plan, please contact an administrator of your organization.",
  "現在の氏名は未設定、または一時的に設定された可能性があります。正しい氏名を入力して保存してください。": "Your name is missing or may have been filled with temporary information. Enter your correct name and save it.",
  "表示言語やプロフィール画像は、必要に応じて設定できます。": "You can set your display language and profile image whenever you like.",
  "氏名、表示言語、アバター画像を確認し、未設定または仮の情報を更新してください。": "Review your name, display language, and avatar, and update any missing or temporary information.",
  "RuleWatcher に 仮登録しました。": "You have provisionally registered for RuleWatcher.",
  "RuleWatcherから記事が削除されました": "Article has been removed from RuleWatcher",
  "RuleWatcherの活用によってどのような環境や社会の問題にアプローチしたいですか？": "Which sustainability field are you most enthusiastic in using RuleWatcher?",
  "Study Group Lounge": "Study Group Lounge",
  "agree-privacy-policy": "I agree to the <l>Privacy Policy</l>.",
  "agree-terms-and-conditions": "I agree to the <l>Terms and Conditions</l>.",
  "download_item": "Download {{count, number}} items",
  "download_next_items": "Download next {{count, number}} items",
  "privacy-policy-url": "https://rulewatcher.notion.site/privacy-policy",
  "data-policy-url": "https://rulewatcher.notion.site/Data-Policy-294e26d944d480199427d47b89e2bfac",
  "searchbox_help": {
    "desc_1": "Separate words with spaces. All of them must match.",
    "desc_2": "Put uppercase OR between every alternative in one search.",
    "desc_3": "Put uppercase NOT before every word you want to exclude.",
    "desc_4": "Enclose multiple words in double quotes to keep them as one phrase.",
    "desc_5": "A normal search adds terms with AND. Join alternatives with OR, or use NOT to exclude terms.",
    "desc_6": "Drag applied search chips between AND, OR, and NOT, or select a chip to remove it.",
    "example_1": "AI law",
    "example_2": "international OR multinational",
    "example_3": "NOT regulation",
    "example_4": "\"Artificial intelligence\"",
    "example_5": "OR robotics",
    "example_6": "Drag the applied search chips",
    "title_1": "Include all words",
    "title_2": "Include any of the words",
    "title_3": "Exclude words",
    "title_4": "Treat multiple words as one phrase",
    "title_5": "Add search terms",
    "title_6": "Adjust the applied search"
  },
  "settings": "Settings",
  "規約 / ポリシー": "Terms / Policies",
  "terms-and-conditions-url": "https://rulewatcher.notion.site/terms-and-conditions",
  "お手数ですが、しばらくしてから再度お試しください。": "We apologize for the inconvenience, but please try again later.",
  "教育機関向けのお知らせを受け取る": "Receive updates for educational organizations",
  "お探しのページが見つかりませんでした。URLが正しいかご確認ください。": "The page you were looking for could not be found. Please check if the URL is correct.",
  "お使いのリンクは無効です": "The link you are using is invalid",
  "以下のケースに該当している可能性がございます。": "It may fall under one of the cases below.",
  "お気に入りの記事をブックマークに追加しましょう。": "Add your favorite articles to bookmarks.",
  "お送りした確認メールのリンクから本登録してください。": "Please click the link in the email to complete the registration.",
  "この画面を閉じると続きからダウンロードできなくなります": "You will not be able to continue downloading if you close this screen",
  "ご使用端末について": "About Your Device",
  "ご入力いただいたメールアドレス宛てに、本人確認メールをお送りいたしました。": "A confirmation email has been sent to the registered email address.",
  "ご利用可能なテーマがありません。": "No themes available.",
  "ご紹介者があれば合わせてお名前をお書きください。": "If you were referred by someone, please provide their name.",
  "しばらくしてもメールが届かない場合は、迷惑メールフォルダをご確認ください。また、登録されていないメールアドレスには送信できません。": "If you do not receive the email after a while, please check your spam folder. Also, we cannot send it to an unregistered email address.",
  "すでにアカウントをお持ちですか？": "Already have an account?",
  "さらに多くの機能を利用できます": "Unlock more features",
  "どうやってRuleWatcherを知りましたか？": "How did you know RuleWatcher?",
  "データポリシー": "Data Policy",
  "もう一度メールアドレスを入力して、招待メールを受け取ってください。": "Please enter your email address again and receive the invitation email.",
  "ようこそ RuleWatcher へ!": "Welcome to RuleWatcher!",
  "エラーが発生しました": "An Error Has Occurred",
  "カテゴリ": "Category",
  "キャンセル": "Cancel",
  "キーワードで絞り込み": "enter keyword...",
  "タイトル": "TITLE",
  "タグ": "Tags",
  "ダウンロードに失敗しました。時間をおいて再度お試しください。": "Download failed. Please try again later.",
  "ダウンロード上限に達しました": "Download limit reached",
  "ダウンロード件数を選択": "Select Number of Downloads",
  "ダウンロード言語": "Download Language",
  "ダウンロード制限": "Download Limit",
  "ダウンロード制限は日本時間の毎月1日にリセットされます": "Download limit resets on the 1st (JST)",
  "データ更新中は、検索結果と異なる記事がダウンロードされる場合があります": "While the data is being updated, articles that differ from the search results may be downloaded.",
  "トップページへ": "Go to Top Page",
  "パスワード": "Password",
  "パスワードが一致しません。": "Passwords do not match.",
  "パスワードが設定されました。": "Password has been set.",
  "パスワードをお忘れですか？": "Forgot password?",
  "パスワードを入力...": "Enter your password...",
  "パスワード再設定用のURLが不正です。": "The password reset URL is invalid.",
  "パスワード再設定の有効期限が切れたため、このリンクは無効です。以下のボタンをクリックし、画面に表示される指示に従ってパスワード設定してください。": "This link is no longer valid because your password reset has expired. Click the button below and follow the on-screen instructions to reset your password.",
  "パスワードの再設定をやり直す": "Reset Password",
  "パスワード設定": "Password setting",
  "パスワード設定用のメールを送信しました。": "Email for password setting has been sent.",
  "パスワード設定用のメールを送信します。登録されているメールアドレスを入力してください。": "We will send you an email to reset your password. Please enter your registered email address.",
  "パスワード（確認用）": "Confirm password",
  "フリートライアル期間中に解約することもできます。": "You can also cancel during the free trial period.",
  "ブックマークはありません": "No bookmarks",
  "ブックマークCSVダウンロード": "Download bookmarked articles CSV",
  "ブックマークした日": "Bookmarked date",
  "ブックマークした日が指定期間に含まれる記事がダウンロードされます": "Articles bookmarked in the selected period will be downloaded.",
  "ブックマークした日の期間は、ブラウザのタイムゾーン（{{timeZone}}）を基準に判定されます": "The bookmarked date period is determined using the browser timezone ({{timeZone}}).",
  "ブックマーク一覧": "Bookmarks",
  "ブックマーク済み": "Bookmarked",
  "ブックマークする": "Bookmark",
  "対象記事": "Target articles",
  "この期間にブックマークした記事はありません": "There are no articles bookmarked in this period.",
  "今日": "Today",
  "前の月": "Previous month",
  "次の月": "Next month",
  "昨日": "Yesterday",
  "直近7日": "Last 7 days",
  "直近30日": "Last 30 days",
  "期間指定": "Custom range",
  "選択した期間の対象記事はすべてCSVに出力しました": "All articles in the selected period have been exported to CSV.",
  "プライバシーポリシー": "Privacy Policy",
  "プランの選択に失敗しました。何度試しても解決しない場合はサポートに連絡いただけると幸いです。": "Plan selection failed. If the issue persists no matter how many times you try, please contact support.",
  "プラン設定": "Plan Settings",
  "契約中のプラン": "Active plan",
  "システム管理者": "System Administrator",
  "システム管理者としてログインしています": "You are logged in as a system administrator",
  "プロフィール": "Profile",
  "プロフィールの更新に失敗しました。時間をおいて再度お試しください。": "Failed to update your profile. Please try again later.",
  "プロフィールを更新しました": "Profile updated.",
  "プロフィール画像": "Profile image",
  "プロフィール画像のアップロードに失敗しました。": "Failed to upload the profile image.",
  "カバー画像": "Cover image",
  "カバー画像のアップロードに失敗しました。": "Failed to upload the cover image.",
  "画像が選択されていません": "No image selected",
  "画像を変更": "Change image",
  "画像を選択": "Select image",
  "PNG / JPEG / GIF / WebP に対応しています。": "PNG, JPEG, GIF, and WebP are supported.",
  "本登録に失敗しました。時間をおいて再度お試しください。": "Failed to complete registration. Please try again later.",
  "本登録を開始します": "Start registration",
  "下のボタンを押すと、メールアドレスの確認を完了して本登録手続きに進みます。": "Click the button below to confirm your email address and continue registration.",
  "本登録を続ける": "Continue registration",
  "言語": "Language",
  "言語設定": "Language",
  "ページが見つかりません": "Page Not Found",
  "メールアドレス": "Email address",
  "メールアドレス変更が完了しました。": "Email address changed.",
  "メールアドレス変更の確認に失敗しました。時間をおいて再度お試しください。": "Failed to confirm your email address change. Please try again later.",
  "メールアドレス変更の申請に失敗しました。時間をおいて再度お試しください。": "Failed to request the email address change. Please try again later.",
  "メールアドレス変更を完了するには、変更前のメールアドレスでログインしてください。": "To complete the email address change, please sign in with your previous email address.",
  "メールアドレス変更を確認します": "Confirm email address change",
  "メールアドレスまたはパスワードが正しくありません。": "Your email address or password is incorrect.",
  "メールアドレスを入力...": "Enter your email address...",
  "メールアドレス変更を完了する": "Complete email address change",
  "メールアドレスを変更": "Change email address",
  "アカウントをお持ちでないですか？": "Don't have an account?",
  "確認メールを送信": "Send confirmation email",
  "確認メールを送信しました。": "Confirmation email sent.",
  "現在のパスワード": "Current password",
  "現在のパスワードが正しくありません。": "The current password is incorrect.",
  "新しいメールアドレス": "New email address",
  "新規登録": "Sign up",
  "ログイン": "Sign In",
  "ログインが必要です": "Sign-in required",
  "ログイン後、新しいメールアドレスに届いた確認リンクをもう一度開いてください。": "After signing in, open the confirmation link sent to your new email address again.",
  "ログイン後、このメールアドレス変更確認画面に戻ります。": "After signing in, you will return to this email address change confirmation page.",
  "ログイン画面へ": "Go to Login",
  "ログアウト": "Sign Out",
  "ログアウトしてログインし直す": "Sign out and sign in again",
  "上のヒートマップから範囲を選択してください。": "Please select a range from the heatmap above.",
  "件": "items",
  "件をダウンロード": "items to download",
  "{{title}}の更新サマリ一覧": "Update summaries for {{title}}",
  "{{title}} の元記事を開く": "Open source article for {{title}}",
  "{{title}} をフィルタ": "Filter by {{title}}",
  "更新サマリ": "Update Summary",
  "更新検知サマリ一覧": "Update Summaries",
  "まだ更新検知レポートはありません。": "No update reports yet.",
  "更新が検知されるとここに表示されます。": "Detected updates will appear here.",
  "データの取得に失敗しました。": "Failed to fetch data.",
  "サイト名で検索": "Search by site name",
  "該当するサイトはありません。": "No matching sites found.",
  "最後に差分を検知した日": "Last update detected",
  "最後にサイトを確認した日": "Last checked",
  "なし": "None",
  "未実行": "Not run",
  "更新検知対象サイトの取得に失敗しました。": "Failed to fetch tracking targets.",
  "トラッキングサイトは毎朝6時に更新をチェックしています。": "Tracking sites are checked for updates every morning at 6:00.",
  "フィルタ解除": "Clear filter",
  "このサイトでフィルタ": "Filter by this site",
  "すべて表示": "Show all",
  "更新検知ページを表示できませんでした": "Unable to display the tracking page.",
  "購読状況の確認に失敗しました。通信状態をご確認のうえ、再度お試しください。": "Failed to verify subscription status. Please check your connection and try again.",
  "再試行": "Retry",
  "レポートの取得に失敗しました。": "Failed to fetch the report.",
  "対象サイト": "Target site",
  "更新確認日時": "Checked at",
  "要約はありません": "No summary available.",
  "※この更新はAIが判定しております。実際の内容は対象サイトをご確認下さい。": "This update was identified by AI. Please check the source site for the actual content.",
  "更新後の全文（今回取得）": "Full content after update (current check)",
  "更新前の全文（前回取得）": "Full content before update (previous check)",
  "取得全文（従来データ）": "Full content (legacy data)",
  "...全文を表示": "...Show full text",
  "Show full text": "Show full text",
  "本文はありません": "No content available.",
  "無題の更新レポート": "Untitled update report",
  "詳細を見る": "View details",
  "対象一覧": "Targets",
  "会員情報": "Member Information",
  "入力...": "Enter...",
  "入力ワード": "Input Word",
  "全件": "All items",
  "公開日時": "Date",
  "filter.label.date": "Date",
  "filter.label.theme": "Theme",
  "filter.label.regionEconomicUnion": "Region / Economic Union",
  "filter.label.countryRegionalOrganization": "Country / Regional Organization",
  "filter.label.organizationType": "Organization type",
  "filter.label.organization": "Organization",
  "filter.label.tag": "Tag",
  "filter.label.tags": "Tags",
  "filter.label.publicationStatus": "Publication Status",
  "filter.placeholder.organizationType": "Search organization type",
  "filter.placeholder.publicationStatus": "Search publication status",
  "filter.placeholder.regionEconomicUnion": "Search region / economic union",
  "filter.placeholder.countryRegionalOrganization": "Search country / regional organization",
  "sort.label.organizationName": "Sort by organization name",
  "sort.label.countryRegionalOrganization": "Sort by country / regional organization",
  "2019年以降の記事のみ収録されています。": "Only articles from 2019 onward are available.",
  "分類されたテーマ": "Classified Themes",
  "利用規約": "Terms and Conditions",
  "割引": "OFF",
  "名": "Given Name",
  "国別言及動向": "Mention Trends by Country",
  "国名": "Country",
  "国名: {{country}}": "Country: {{country}}",
  "地球環境": "Global Environment",
  "変更": "change",
  "契約状況": "Contract Status",
  "姓": "Family Name",
  "年払い": "Yearly",
  "年払いで{{percentage}}%お得": "Yearly {{percentage}}% off",
  "戻る": "Back",
  "技術と社会": "Tech and Society",
  "政府やNGO/シンクタンク/国際機関の発信情報を一元化 - 様々な分析画面で新たな発見を": "Centralisation of information originating from governments, NGOs/think tanks/international organisations - various analysis screens for new discoveries",
  "文字を入力して絞り込んでください。": "Enter keyword to refine choices.",
  "新しいパスワードを入力...": "Enter your new password...",
  "新しいパスワードを再入力...": "Re-enter your new password...",
  "新しい経済": "New Economy",
  "暮らしと権利": "Human Rights",
  "最新の記事から選択した件数ダウンロードされます": "The selected number of latest articles will be downloaded.",
  "月": "Month",
  "月払い": "Monthly",
  "月間ダウンロード": "Monthly Download",
  "月額{{percentage}}%お得": "Monthly {{percentage}}% off",
  "期間": "Date",
  "期間: {{start}} ~ {{end}}": "Duration: {{start}} ~ {{end}}",
  "条件に合致するデータがありませんでした、条件を変更して再度検索してください。": "There was no data matching the criteria. Please change the criteria and search again.",
  "検索": "Search",
  "analyze.search.freewordPlaceholder": "Enter keyword",
  "analyze.search.freewordErrors.emptyCommand": "Enter a search term.",
  "analyze.search.freewordErrors.emptyOperator": "Add a search term after OR or NOT.",
  "analyze.search.freewordErrors.emptyPhrase": "Quoted phrases cannot be empty.",
  "analyze.search.freewordErrors.incompatibleTarget": "That search term can no longer be moved there.",
  "analyze.search.freewordErrors.invalidExpression": "Enter search terms, optionally joined by one type of operator.",
  "analyze.search.freewordErrors.legacyQuery": "Remove this saved search before adding another term.",
  "analyze.search.freewordErrors.manualGrouping": "Add terms separately and group them by dragging the applied chips.",
  "analyze.search.freewordErrors.missingPositiveTerm": "Add a search term before using OR.",
  "analyze.search.freewordErrors.mixedConnectors": "Use only one connector type in each search.",
  "analyze.search.freewordErrors.tooLong": "The combined search is longer than 100 characters.",
  "analyze.search.freewordErrors.unmatchedQuote": "Close the quoted phrase before searching.",
  "analyze.search.scope.explanation": "Japanese searches include titles and summaries, while English searches also include full text.",
  "analyze.search.scope.japanese": "Showing results for \"{{keyword}}\" matched in titles and summaries",
  "analyze.search.scope.english": "Showing results for \"{{keyword}}\" matched in titles, summaries and article bodies",
  "analyze.search.scope.both": "Showing results for \"{{keyword}}\" matched in titles and summaries (article bodies included for latin terms)",
  "検索のヒント": "Search Tips",
  "検索ワード": "Search Word",
  "検索ワードは{{maxSearchKeywordLength}}文字以内で入力してください。": "Please enter a search term within {{maxSearchKeywordLength}} characters.",
  "検索ワード英語翻訳": "Translate search word to English",
  "記事検索": "Article Search",
  "検索条件に一致する記事がダウンロードされます": "Articles that match your search criteria will be downloaded",
  "検索結果": "Search Results",
  "次の": "Next",
  "削除済みの記事はCSVに含まれません": "Deleted articles are not included in the CSV.",
  "氏名（名）を入力...": "Enter given name...",
  "氏名（姓）を入力...": "Enter family name...",
  "現在、このアプリケーションはパソコンおよびタブレットでのご利用を推奨しております。": "Currently, this application is optimized for use on computers and tablets.",
  "現在お住まいの国・地域": "Current Country/Region of Residence",
  "画面サイズの小さいデバイスでは、表示が意図通りに行われない可能性がありますので、できるだけ大きめの画面のデバイスをご使用ください。何卒ご理解のほど、よろしくお願い申し上げます。": "There is a possibility that it may not display as intended on devices with smaller screens. Therefore, we recommend using a device with a larger screen for the best experience. Thank you for your understanding.",
  "※第三者によるなりすましを防ぐなどセキュリティ上の理由から、有効なリンクの数・期限・使用回数を限定しております。": "For security reasons, including preventing impersonation by third parties, we limit the number, expiration period, and usage count of valid links.",
  "登録できないメールアドレスです。すでにご登録済みの方は、ログインをお試しください。": "You cannot register with this email address. If you are already registered, please Sign in.",
  "登録期限が切れてしまいました。": "The registration period has expired.",
  "登録期限切れ": "Provisional Registration Expired",
  "本登録ページ": "Registration page",
  "まだ本登録は完了していません": "Registration is not complete yet.",
  "仮登録メールを受け取る": "Receive provisional registration email",
  "確認メールの有効期限が切れています。下記から、再度メールアドレスをご登録ください。": "The confirmation email has expired. Please register your email address again from below.",
  "仮登録メールの有効期限が切れています。下記から仮登録メールを再発行してください。": "The provisional registration email has expired. Please reissue the provisional registration email below.",
  "仮登録メールを再発行する": "Reissue provisional registration email",
  "本登録ページ（まだ本登録は完了していません）": "Registration page (registration is not complete yet).",
  "この確認リンクはすでに使用されています。下記から仮登録メールを再発行してください。": "This confirmation link has already been used. Please reissue the provisional registration email below.",
  "よくあるケース：": "Common cases:",
  "同じメールアドレスで2回以上仮登録手続きが行われた": "Provisional registration was completed more than once with the same email address.",
  "最新の仮登録メールに記載されているリンクをお使いください。": "Please use the link in the latest provisional registration email.",
  "URLの文字列が途切れている/不要な文字列を含んでいる/メールの自動翻訳機能によりリンクが変更されてしまった": "The URL is truncated, contains unnecessary characters, or was changed by an email auto-translation feature.",
  "再度正しいリンクをご利用ください。": "Please use the correct link again.",
  "→": "→",
  "管理画面へ": "Go to Admin Panel",
  "キーワードでタグを検索...": "Search tags by keyword...",
  "{{articleCount}}件の記事": "{{articleCount}} Articles",
  "約 {{articleCount}} 件": "About {{articleCount}} results",
  "並び順": "Sort",
  "新しい順": "Newest",
  "関連度順": "Relevance",
  "約 {{articleCount}} 件の結果 [{{start}}〜{{end}}件を表示中]": "About {{articleCount}} results [Showing {{start}}–{{end}}]",
  "ページの先頭に戻る": "Back to top",
  "前のページ": "Previous page",
  "次のページ": "Next page",
  "ページ指定": "Go to page",
  "ページ番号を入力": "Enter page number",
  "組織タイプ": "Organization Type",
  "組織": "Organization",
  "組織名": "Organization Name",
  "翻訳中にエラーが発生しました": "Translation failed",
  "表示件数": "Items displayed",
  "表示間隔": "Date Interval",
  "テーマ・タグ": "Themes & Tags",
  "要約": "Summary",
  "article.label.theme": "#THEME",
  "article.label.tags": "TAGS",
  "言及された人物": "Mentioned People",
  "言及された地名": "Mentioned Locations",
  "言及された組織": "Mentioned Organizations",
  "キャンペーン特典適用中": "Campaign benefit applied",
  "割引が適用されています": "Discount applied",
  "無料トライアル{{days}}日が適用されています": "{{days}}-day free trial applied",
  "割引と無料トライアル{{days}}日が適用されています": "Discount and {{days}}-day free trial applied",
  "トライアル中は支払い方法の入力が不要です": "No payment method is required during the trial.",
  "記事数": "Article Count",
  "読み込み中...": "Loading...",
  "調査・検索したい分野を選択してください": "Select a theme to begin",
  "請求情報の管理": "Billing Management",
  "追加の社会課題テーマと、より高度な分析機能をご利用いただけます。": "Add additional social issue themes and advanced analysis features.",
  "さらなる可能性を解放しましょう。": "UNLOCK THE FULL POTENTIAL.",
  "以下の RuleWatcher Plus 機能でリサーチを強化しましょう。": "RuleWatcher Plus brings you professional features seen below to supercharge your research and understanding.",
  "RuleWatcher Plus の機能紹介": "RuleWatcher Plus feature showcase",
  "RuleWatcher biz. の機能紹介": "RuleWatcher biz. feature showcase",
  "RuleWatcher biz. の機能一覧": "RuleWatcher biz. features",
  "RuleWatcher biz. の機能で、組織のリサーチをさらに強化しましょう。": "RuleWatcher biz. gives your organization more ways to deepen and expand its research.",
  "biz. 限定テーマ4種": "4 biz. Themes",
  "組織向けの4つの限定テーマで、さらに専門的な領域まで調査範囲を広げられます。": "Expand your research into specialized fields with four themes exclusive to Biz.",
  "カスタムタグ作成": "Custom-made Tags",
  "組織の調査課題に合わせて、独自のタグの作成依頼が行えます": "Request custom tags tailored to your organization's research needs. Our team will review your request and create them for you.",
  "情報ソース追加リクエスト": "Source Addition Requests",
  "調査対象に加えたい媒体や情報ソースの追加をリクエストできます。": "Request additional publications and information sources for your research.",
  "CSVダウンロード 10,000件": "10,000 CSV Downloads",
  "検索結果から毎月最大10,000件の記事をCSVで書き出せます。": "Export up to 10,000 articles from your search results each month.",
  "クレジットカード・請求書払い": "Credit Card or Invoice",
  "クレジットカードまたは請求書から、組織に合った支払い方法を選べます。": "Choose the payment method that best suits your organization.",
  "保存フィルター": "Saved Filter",
  "アラート": "Alert",
  "検索結果をCSVで書き出し、詳しい分析やレポート作成、共有に活用できます。Plusでは毎月最大3,000件の記事をダウンロードできます。": "Export search results to CSV for deeper analysis, reporting, and sharing. Plus lets you download up to 3,000 articles each month.",
  "検索結果を形づくるトピックをひと目で把握できます。記事のまとまりを大きさと色で探索し、主要なテーマや新たな傾向を発見できます。": "See the topics shaping your results at a glance. Explore clustered articles by size and color to spot dominant themes and emerging patterns.",
  "注目度の変化を時系列で追跡できます。期間ごとのトピックを比較し、上昇中・減少中・継続中の傾向を把握できます。": "Track how attention changes over time. Compare topics across periods to understand rising, fading, and persistent trends.",
  "よく使う検索条件を保存し、すべての設定を保ったままワンクリックで呼び出せます。": "Save the searches you return to most and reopen them in one click, with every condition preserved.",
  "保存したフィルターをメールアラートに設定し、調査条件に合う新着記事をすぐに確認できます。": "Turn a saved filter into an email alert and stay updated when new articles match your research.",
  "厳選された5つの追加テーマを利用して調査範囲を広げ、より多くの政策分野を横断するつながりを発見できます。": "Unlock five additional curated themes to broaden your coverage and discover connections across more policy areas.",
  "前のPlus機能を表示": "Show previous Plus feature",
  "次のPlus機能を表示": "Show next Plus feature",
  "{{feature}}の紹介画像": "{{feature}} preview",
  "{{feature}}の画像を追加予定": "{{feature}} image coming soon",
  "{{feature}}を表示": "Show {{feature}}",
  "無料トライアルあり": "Free trial included",
  "ウェブサイトで詳細を見る": "See more on the website",
  "案内を閉じる": "Dismiss",
  "7日間の無料トライアルを始める": "Start 7 day free trial",
  "高度な分析ツール": "Advanced Analysis Tools",
  "TreeMap と Transition で検索結果の傾向を立体的に把握できます。": "such as TreeMap and Transition help you gain insight into your search.",
  "フィルター保存": "Save Filter Presets",
  "よく使う条件を保存し、ワンクリックで呼び出せます。": "for easy access to your topics of interest.",
  "5つのテーマ追加": "5 More Themes",
  "学びを広げられます。": "to learn and understand.",
  "CSV ダウンロード 3000件/月": "3000 CSV Downloads",
  "月 3,000 件までエクスポートできます。": "per month to use for all intents and purposes.",
  "アラート通知": "Set Alerts",
  "フィルター条件に合う新着記事を通知で受け取れます。": "to be notified when there is a new article on your filtered search.",
  "RuleWatcher Plus の機能でリサーチをさらに強化できます。": "RuleWatcher Plus brings you professional features seen below to supercharge your research and understanding.",
  "{{days}}日間無料で試す": "Try free for {{days}} days",
  "無料で試す": "Try free",
  "7日間の無料トライアルを開始": "Start 7 day free trial",
  "7日間無料で試す": "Try free for 7 days",
  "トライアル期間中はダウンロード上限100件です。": "* Downloads are limited to 100 items during the trial.",
  "日本語": "Japanese",
  "英語": "English",
  "ブロック: {{label}}": "Block: {{label}}",
  "ダブルクリックでブロックを選択します。": "Double-click to select a block.",
  "全体表示に戻るには、ESCキー押下または右ダブルクリックしてください。": "To return to the full view, Press Esc or right-double-click.",
  "TreeMapの操作ヒントを閉じる": "Hide TreeMap controls help",
  "TreeMapの操作ヒントを表示する": "Show TreeMap controls help",
  "RuleWatcherに登録すると、記事の調査・参照を継続しやすくなります。": "Register with RuleWatcher to make article research and reference tracking easier.",
  "続けて記事を便利に活用するには、アカウント登録をおすすめします。": "For a better article experience, we recommend creating an account.",
  "QRコードを開く": "Open QR code",
  "記事を共有": "Share article",
  "その他のオプション": "More options",
  "記事リンクをコピー": "Copy article link",
  "記事のリンクをコピーしました": "Article link copied",
  "コピーしました": "Copied",
  "原文サイトを開く": "Open original article site",
  "記事詳細を開く": "Open article detail",
  "共有": "Share",
  "QRコード": "QR Code",
  "QRコードで共有": "Share with QR code",
  "記事URL": "Article URL",
  "読み込み中": "Loading",
  "QRコードを閉じる": "Close QR code",
  "記事詳細のQRコード": "Article detail QR code",
  "QRコードを生成できませんでした": "Could not generate QR code",
  "記事が見つかりませんでした。": "Could not find this article.",
  "ログインする": "Log in",
  "TreeMap と Transition で検索結果の傾向を直感的に把握できます。": "such as TreeMap and Transition help you gain insight into your search.",
  "テーマの幅を広げて学びを深められます。": "Unlock additional curated themes to expand and deepen your learning.",
  "月 3,000 件まで記事をエクスポートできます。": "Export up to 3,000 articles per month as CSV.",
  "条件に合う新着記事をメールでお知らせします。": "Get emails when new articles match your filters.",
  "送信": "Send",
  "選択いただいたテーマが存在しないか、ご利用できないテーマです。": "The theme you selected does not exist or is unavailable.",
  "選択中の範囲の記事": "Articles in the Selected Range",
  "選択肢数が表示上限を超えています。": "Too many options to display.",
  "閉じる": "Close",
  "７日フリートライアルで開始できます。": "You can start with a 7-day free trial.",
  "deleted-article-link-text": "The original link is <l>here</l>.",
  "テーマ横断検索": "Search Across all Themes",
  "テーマで検索": "Search by Theme",
  "世界の政策変化を一次情報から追跡": "Track Global Policy Changes from Primary Sources.",
  "150以上の国の政府・国際機関から最新の政策情報を収集します。": "Gather the latest policy information from governments and international organizations in 150+ countries.",
  "政策情報を検索": "Search policy information",
  "テーマから検索": "Search from theme",
  "SDGsから検索": "Search from SDGs",
  "sdg.goal.1": "SDG 1: No Poverty",
  "sdg.goal.2": "SDG 2: Zero Hunger",
  "sdg.goal.3": "SDG 3: Good Health and Well-being",
  "sdg.goal.4": "SDG 4: Quality Education",
  "sdg.goal.5": "SDG 5: Gender Equality",
  "sdg.goal.6": "SDG 6: Clean Water and Sanitation",
  "sdg.goal.7": "SDG 7: Affordable and Clean Energy",
  "sdg.goal.8": "SDG 8: Decent Work and Economic Growth",
  "sdg.goal.9": "SDG 9: Industry, Innovation and Infrastructure",
  "sdg.goal.10": "SDG 10: Reduced Inequalities",
  "sdg.goal.11": "SDG 11: Sustainable Cities and Communities",
  "sdg.goal.12": "SDG 12: Responsible Consumption and Production",
  "sdg.goal.13": "SDG 13: Climate Action",
  "sdg.goal.14": "SDG 14: Life Below Water",
  "sdg.goal.15": "SDG 15: Life on Land",
  "sdg.goal.16": "SDG 16: Peace, Justice and Strong Institutions",
  "sdg.goal.17": "SDG 17: Partnerships for the Goals",
  "絞り込まずに検索": "Search without filtering",
  "キーワードの関係からたどる": "Navigate using the relations of keywords",
  "課題は相互につながっています。ひとつを解くと、別の課題も動きます。そのつながりを見つけましょう。": "Issues are interconnected. Solve one, and another moves. Discover such connections.",
  "TagViewを開く": "Open TagView",
  "人獣共通感染症": "zoonotic virus",
  "気候変動適応": "Climate Adaptation",
  "グローバルヘルス": "Global Health",
  "淡水資源": "Water Issues",
  "フードシステム": "Food System",
  "home.category.globalEnvironment": "GLOBAL ENVIRONMENT",
  "home.category.techAndSociety": "TECH AND SOCIETY",
  "home.category.humanRights": "HUMAN RIGHTS",
  "home.category.newEconomy": "NEW ECONOMY",
  "すべてのテーマ": "All Themes",
  "テーマ": "Themes",
  "テーマ：": "Theme:",
  "全部見る...": "See all...",
  "総数": "Total Count",
  "キーワードを検索（部分一致）": "Phrase search (partial match) by tag-name or tag-keyword",
  "タグ検索": "Tag Search",
  "ズームイン": "Zoom In",
  "ズームアウト": "Zoom Out",
  "リセット": "Reset",
  "選択テーマへズーム": "Zoom to Selected Theme",
  "テーマへ移動...": "Go to Theme",
  "テーマ解除": "Clear Theme",
  "テーマ移動を解除": "Clear Theme Focus",
  "社会課題": "Social Issues",
  "はい": "Yes",
  "いいえ": "No",
  "未設定": "Not Set",
  "フィルタタグ詳細情報": "Filter Tag Details",
  "タグ: AND": "Tag: AND",
  "タグ: OR": "Tag: OR",
  "タグ: NOT": "Tag: NOT",
  "表示設定": "Settings",
  "タグ表示設定": "Tag Display Settings",
  "タグ：": "Tags:",
  "Show More": "Show More",
  "Show Less": "Show Less",
  "閉じる ▲": "Close ▲",
  "開く ▼": "Open ▼",
  "タグを探索": "Explore RuleWatcher with TagView",
  "TagViewのイメージ": "Image of TagView",
  "フィルタ条件にヒットする記事件数： {{articleCount}} ": "Number of articles matching filter criteria: {{articleCount}} ",
  "アシストタグ": "Assist Tags",
  "クロスイシュータグ": "Cross-Issue Tags",
  "クロスタグ": "Cross Tags",
  "イシュータグ": "Issue Tags",
  "ノーマルタグ": "Normal Tags",
  "テーマタグ": "Theme Tags",
  "アシストタグの説明": "General tags associated with all themes (e.g., tax, public comments)",
  "クロスイシュータグの説明": "Tags referring to social issues spanning multiple themes",
  "クロスタグの説明": "General tags spanning multiple themes",
  "イシュータグの説明": "Tags referring to social issues",
  "ノーマルタグの説明": "General tags associated with any theme",
  "表示": "Show",
  "非表示": "Hide",
  "上に移動": "Move Up",
  "下に移動": "Move Down",
  "左に移動": "Move Left",
  "右に移動": "Move Right",
  "このフィルタ条件で記事を見る": "View Articles with this Filter",
  "この条件で記事を見る": "View Articles with this Criteria",
  "該当するタグが見つかりません": "No matching tags found",
  "フィルターで選択中": "Currently Selected in Filter",
  "Assist Tags": "Assist Tags",
  "Cross-Issue Tags": "Cross-Issue Tags",
  "Cross Tags": "Cross Tags",
  "Issue Tags": "Issue Tags",
  "Issue Tag": "Issue Tag",
  "Normal Tags": "Normal Tags",
  "Normal Tag": "Normal Tag",
  "Theme": "Theme",
  "関連テーマ": "Related Themes",
  "記事": "Article(s)",
  "説明未設定": "Description not set yet",
  "フィルター(AND)に追加": "Add to Filter (AND)",
  "フィルター(OR)に追加": "Add to Filter (OR)",
  "フィルター(NOT)に追加": "Add to Filter (NOT)",
  "RuleWatcherタグを探索し、選択する": "Explore and select RuleWatcher tags",
  "適用": "Apply",
  "もどる": "Back",
  "選択解除": "Reset Selection",
  "もしかして・・・": "Suggested tags",
  "検索候補": "Search Suggestions",
  "クリア": "Clear",
  "検索結果をクリア": "Clear Search Results",
  "このテーマの記事を閲覧するには有料契約が必要です。": "A paid subscription is required to view articles on this theme.",
  "ノードタイプ表示設定": "Node Type Display Settings",
  "ネットワークに表示するノードを選択": "Select Nodes to Display on Network",
  "networkHelp.title": "Operation Guide",
  "networkHelp.openLabel": "Help",
  "networkHelp.close": "Close",
  "networkHelp.hideForever": "Don't show again",
  "networkHelp.pressKeyToToggle": "Press",
  "networkHelp.toToggle": "to toggle",
  "networkHelp.pan.title": "Pan",
  "networkHelp.pan.desc": "Drag or use mouse wheel to move canvas",
  "networkHelp.zoom.title": "Zoom",
  "networkHelp.zoom.desc": "Ctrl + wheel or use right slider to zoom",
  "networkHelp.node.title": "Tag Operations",
  "networkHelp.node.desc": "Click to view details and show connections to related themes",
  "networkHelp.filter.title": "Display Settings",
  "networkHelp.filter.desc": "Toggle visibility of tag types",
  "含める": "Include",
  "含めない": "Exclude",
  "パン": "Pan",
  "ドラッグまたはマウスホイールでキャンバスを移動します。ホイール上下、Shift＋ホイール左右": "Drag or use the mouse wheel to move the canvas. Use wheel up/down or Shift + wheel left/right.",
  "ズーム": "Zoom",
  "ピンチまたは Ctrl + マウスホイール、 右のスライダー +/- ボタンで拡大縮小できます。": "You can zoom in and out using pinch gestures or Ctrl + mouse wheel, and the right slider +/- buttons.",
  "タグ(ノード)操作": "Tag (Node) Operations",
  "タグ(ノード)をクリックして詳細を表示。関連テーマへ線(エッジ)を表示します。": "Click on a tag (node) to view details. Lines (edges) to related themes will be displayed.",
  "タグ種別の表示/非表示切り替えを行えます。": "You can toggle the display of tag types.",
  "タグ種類の説明": "Description of Tag Types",
  "Content": "Content",
  "Filter": "Filter",
  "Source": "Source",
  "Bookmarks": "Bookmarks",
  "All Sources": "All Sources",
  "Web Tracker": "Web Tracker",
  "CSV Download": "CSV Download",
  "Goal {{goal}}": "Goal {{goal}}",
  "Navigate using the relations of keywords": "Navigate using the relations of keywords",
  "Open TagView": "Open TagView",
  "Saved filters": "Saved filters",
  "SDGs": "SDGs",
  "Coming Soon": "Coming Soon",
  "ノーマルタグを表示": "Show Normal Tags",
  "保存されたフィルター": "Saved Filter",
  "保存されたフィルタ": "Saved Filters",
  "保存済み": "Saved",
  "フィルターの適用": "Apply Filter",
  "フィルターを保存": "Save Filter",
  "保存可能なフィルター数が上限に達しています。既存のフィルターを上書きするか、不要なフィルターを削除してから新規作成してください。": "The number of saved filters has reached the limit. Please overwrite an existing filter or delete unnecessary filters before creating a new one.",
  "新規作成": "Create New",
  "上書き": "Overwrite",
  "上書きするフィルタを選択": "Select filter to overwrite",
  "上書き保存": "Overwrite Save",
  "フィルタ名": "Filter Name",
  "フィルタ名を入力してください": "Please enter a filter name",
  "通知を受け取る": "Receive Notifications",
  "日本時間午前8時に条件に一致する新着記事があれば通知されます。": "You will be notified at 8:00 (JST) if there are new articles matching the conditions.",
  "※通知できるフィルタ条件は1つまでです。他のフィルターに通知設定されている場合は他のフィルターはOFFになります。": "※Only one filter condition can be set for notifications. If other filters have notification settings, those filters will be turned OFF.",
  "重要なお知らせ": "Important Notice",
  "通知設定は1つの検索条件に対してのみ有効です。他の検索条件で通知設定をオンにしている場合、それらの設定は自動的にオフになります。": "Notification settings can only be enabled for one search condition at a time. If you have notification settings enabled for other search conditions, those will be automatically turned OFF.",
  "通知機能について": "About Notification Features",
  "通知タイミング": "Notification Timing",
  "毎朝8時以降、新しい記事が追加されたタイミングで通知します（1日最大1回）": "Notifications are sent after 8 AM when new articles are added (maximum once per day)",
  "通知対象の記事": "Target Articles",
  "以下の条件全てを満たす記事が対象です": "Articles that meet ALL of the following conditions:",
  "過去3日以内に検索可能になった記事": "Articles that became searchable within the past 3 days",
  "前回通知時以降に新しく追加された記事": "Articles that have not been sent in previous notifications",
  "ご注意": "Please Note",
  "グローバルな記事収集を行っているため、時差の影響により記事の公開から通知まで時間差が発生する場合がございます。": "Due to global article collection, there may be time differences between article publication and notification delivery due to time zone effects.",
  "保存": "Save",
  "設定を保存しました": "Settings saved",
  "変更はまだ保存されていません": "Changes have not been saved yet.",
  "フィルターの保存に失敗しました": "Failed to save filter",
  "保存されたフィルタの読み込みに失敗しました": "Failed to load saved filters",
  "保存されたフィルタはありません": "No saved filters",
  "保存可能なフィルタ数の上限に達しています。上書き機能をご利用ください。": "You have reached the maximum number of saved filters. Please use the overwrite function.",
  "保存されたフィルタがありません。新規作成をご利用ください。": "No saved filters. Please create a new one.",
  "既に検索条件が設定されています。保存されたフィルター「{{filterName}}」を適用しますか？": "Search conditions are already set. Do you want to apply the saved filter \"{{filterName}}\"?",
  "適用する": "Apply",
  "反映": "Apply",
  "編集": "Edit",
  "削除": "Delete",
  "タグを削除": "Delete tag",
  "タグを削除しますか？": "Do you want to delete the tag?",
  "今後表示しない": "Don't show again",
  "フィルタ名の編集": "Edit Filter Name",
  "更新": "Update",
  "更新中...": "Updating...",
  "削除中...": "Deleting...",
  "フィルタの削除": "Delete Filter",
  "この操作は取り消すことができません。": "This action cannot be undone.",
  "「{{filterName}}」を削除しますか？": "Delete \"{{filterName}}\"?",
  "アクセス権限がありません": "Access Denied",
  "トップに戻る": "Back to Top",
  "通知について": "About Notifications",
  "{{date}}実行の「{{filterName}}」の新着記事": "New articles for \"{{filterName}}\" executed on {{date}}",
  "組織一覧": "Organizations",
  "情報源一覧": "Information Sources",
  "{{value}}件": "{{value}} items",
  "フィルター": "Filter",
  "適用中": "Active",
  "フリーテキスト検索": "Free Text Search",
  "キーワードを入力": "Enter keyword",
  "条件をクリア": "Clear Conditions",
  "この条件で検索": "Search with these conditions",
  "組織の取得に失敗しました。時間をおいてから再度お試しください。": "Failed to fetch organizations. Please try again later.",
  "該当する組織がありません。": "No organizations found.",
  "{{current}}/{{last}}ページ": "Page {{current}}/{{last}}",
  "最新記事日": "Latest Article Date",
  "最古記事日": "Oldest Article Date",
  "キーワードで検索": "Search by keyword",
  "選択したフィルターは即時に適用されます。": "Selections apply immediately.",
  "このメールアドレスはすでに使用されています": "This email address is already in use",
  "確認しようとしたメールアドレスは、すでに別のアカウントで使用されています。": "The email address you tried to confirm is already used by another account.",
  "プロフィール画面から別のメールアドレスで変更を再申請してください。": "Please request the email address change again from your profile using a different email address.",
  "プロフィールに戻る": "Back to profile",
  "選択": "Select",
  "Type something...": "Type something...",
  "候補がありません": "No options",
  "候補の取得に失敗しました。再試行してください。": "Failed to load options. Please retry.",
  "候補の一部情報を取得できませんでした。": "Some option details could not be loaded.",
  "入力を続けて候補を絞り込んでください。": "Keep typing to narrow the options.",
  "適用": "Applied",
  "適用中": "Applied",
  "候補": "Suggested",
  "候補をすべて非表示": "Dismiss",
  "{{tag}}をフィルタから外す": "Remove {{tag}} from filter",
  "{{tag}}を候補から外す": "Remove {{tag}} from suggestions",
  "検索結果に該当なし": "No matches in the search results",
  "home.continueWithoutFilter": "Continue without filter",
  "home.sdg.search": "Search from SDG",
  "home.sdg.searchFrom": "Search from",
  "auth.login.welcomeBack": "Welcome Back",
  "auth.login.description": "Dive back into the world's largest dataset of primary information from governments, international organizations, and NGOs, updated daily.",
  "auth.login.submit": "Login",
  "一部適用済み": "Partially applied",
  "除外条件にも含まれています": "Also included in exclusions",
  "analyze.emptyState.firstLine": "We looked far and wide, but there were no results.",
  "analyze.emptyState.secondLine": "Try removing some filters from the “Applied” at the top.",
  "analyze.emptyState.example": "Example: Japanese “ゲノム編集” → “Genome editing”"
}
